import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

type Props = {
  onActionEdit: (
    idGestaoDistribuicaoEpi: number | null,
    openState: boolean,
  ) => void;
  onActionDelete: (
    idGestaoDistribuicaoEpi: number | null,
    openState: boolean,
  ) => void;
  onActionValidate: (
    idGestaoDistribuicaoEpi: number,
    openState: boolean,
  ) => void;
  onActionVisualize: (idGestaoDistribuicaoEpi: number) => void;
  onActionAuditoria: (idGestaoDistribuicaoEpi: number) => void;
  onActionViewItems: (row: any) => void; 
};

export const GenerateGestaoDistribuicaoEpiColumns = ({
  onActionEdit,
  onActionDelete,
  onActionValidate,
  onActionVisualize,
  onActionAuditoria,
  onActionViewItems,
}: Props): GridColDef[] => {
  return [
    {
      field: "funcionario",
      filterable: false,
      headerName: "Funcionario",
      width: 150,
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value}
          </div>
        );
      },
    },
    {
      field: "nomeCargo",
      filterable: false,
      headerName: "Cargo",
      width: 100,
      minWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value}
          </div>
        );
      },
    },
    {
      field: "nomeCentroCusto",
      filterable: false,
      headerName: "Centro Custo",
      width: 100,
      minWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value}
          </div>
        );
      },
    },
    {
      field: "nomeCentroCustoSaida",
      filterable: false,
      headerName: "Centro Custo Saída",
      width: 100,
      minWidth: 100,
      flex: 1,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value}
          </div>
        );
      },
    },
    {
      field: "verItens",
      filterable: false,
      headerName: "EPIs Distribuídos", 
      width: 130,
      sortable: false,
      resizable: false,
      align: "center",      
      headerAlign: "center", 
      renderCell: ({ row }) => {
        const qtdItens = row.itens ? row.itens.length : 0;

        return (
          <div className="w-full h-full flex items-center justify-center text-center text-xs py-2">
            <Button
              onMouseDown={() => onActionViewItems(row)}
              sx={{
                fontSize: 11,
                paddingX: ".4rem",
                paddingY: 0,
                background: "#e6e6e6",
                borderLeft: ".3rem solid #45b6af",
                borderRadius: 0,
                color: "black",
                fontWeight: "normal",
                width: "9.5rem",
              }}
            >
              Ver Lista ({qtdItens})
            </Button>
          </div>
        );
      },
    },
    {
      field: "validacao",
      filterable: false,
      headerName: "Validação",
      width: 100,
      minWidth: 100,
      sortable: false,
      renderCell: ({ row }) => {
        const idGestaoDistribuicaoEpi = row.idGestaoDistribuicaoEpi;
        const jaEstaAssinado = row.validacao === true;

        if (jaEstaAssinado) {
          return (
            <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
              <div
                className={`
                  flex flex-col justify-center items-center text-center text-xs font-bold 
                  text-white bg-green-600 px-4 py-1 rounded cursor-not-allowed
                `}
              >
                Assinado
              </div>
            </div>
          );
        }
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            <div
              className={`
                flex flex-col justify-center items-center text-center text-xs font-bold 
                text-white bg-red-600 hover:bg-red-500 cursor-pointer px-4 py-1 rounded
                active:bg-red-700
              `}
              onClick={() => onActionValidate(idGestaoDistribuicaoEpi, true)}
            >
              Assinar
            </div>
          </div>
        );
      },
    },
    {
      field: "nomeVerificadoPor",
      filterable: false,
      headerName: "Verificado Por",
      width: 140,
      minWidth: 140,
      flex: 1,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value ? value : "-"}
          </div>
        );
      },
    },
    {
      field: "dataEntrega",
      filterable: false,
      headerName: "Data de Entrega",
      width: 90,
      minWidth: 90,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value && dayjs.utc(value).local().format("DD/MM/YYYY")}
          </div>
        );
      },
    },
    {
      field: "dataCadastro",
      filterable: false,
      headerName: "Data de Cadastro",
      width: 90,
      minWidth: 90,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value && dayjs.utc(value).local().format("DD/MM/YYYY")}
          </div>
        );
      },
    },
    {
      field: "visualizar",
      filterable: false,
      headerName: "Comprovante", 
      width: 130,
      sortable: false,
      resizable: false,
      align: "center",      
      headerAlign: "center", 
      renderCell: ({ row }) => {
        const jaEstaAssinado = row.validacao === true;

        if (!jaEstaAssinado) {
          return <div className="w-full h-full flex items-center justify-center"></div>;
        }

        const maxSize = 20;
        const arquivoNome = "Ver Assinatura"; 
        const idGestaoDistribuicaoEpi = row.idGestaoDistribuicaoEpi;

        return (
          <div className="w-full h-full flex items-center justify-center text-center text-xs py-2">
            <Button
              onMouseDown={() => onActionVisualize(idGestaoDistribuicaoEpi)}
              sx={{
                fontSize: 11,
                paddingX: ".4rem",
                paddingY: 0,
                background: "#e6e6e6",
                borderLeft: ".3rem solid #45b6af",
                borderRadius: 0,
                color: "black",
                fontWeight: "normal",
                width: "9.5rem",
              }}
            >
              {arquivoNome && arquivoNome.length > maxSize
                ? `${arquivoNome.substring(0, maxSize)}...`
                : arquivoNome}
            </Button>
          </div>
        );
      },
    },
    {
      field: "AuditotiaBiometria",
      filterable: false,
      headerName: "Auditoria",
      width: 130,
      sortable: false,
      resizable: false,
      align: "center",      
      headerAlign: "center", 
      renderCell: ({ row }) => {
        const jaEstaAssinado = row.validacao === true;

        if (!jaEstaAssinado) {
          return <div className="w-full h-full flex items-center justify-center"></div>;
        }

        const maxSize = 20;
        const arquivoNome = "Ver Biometria"; 
        const idGestaoDistribuicaoEpi = row.idGestaoDistribuicaoEpi;

        return (
          <div className="w-full h-full flex items-center justify-center text-center text-xs py-2">
            <Button
              onMouseDown={() => onActionAuditoria(idGestaoDistribuicaoEpi)}
              sx={{
                fontSize: 11,
                paddingX: ".4rem",
                paddingY: 0,
                background: "#e6e6e6",
                borderLeft: ".3rem solid #45b6af", 
                borderRadius: 0,
                color: "black",
                fontWeight: "normal",
                width: "9.5rem",
              }}
            >
              {arquivoNome && arquivoNome.length > maxSize
                ? `${arquivoNome.substring(0, maxSize)}...`
                : arquivoNome}
            </Button>
          </div>
        );
      },
    },
    {
      field: "acoes",
      sortable: false,
      filterable: false,
      headerName: "Ações",
      width: 90,
      resizable: false,
      renderCell: ({ row }) => {
        const idGestaoDistribuicaoEpi = row.idGestaoDistribuicaoEpi;
        const jaEstaAssinado = row.validacao === true;

        return (
          <div className="w-full h-full flex items-center justify-center gap-0">
            <IconButton
              disabled={jaEstaAssinado}
              onClick={() => onActionEdit(idGestaoDistribuicaoEpi, true)}
            >
              <DynamicIcon
                nameIcon="EditRounded"
                size={20}
                className={
                  jaEstaAssinado
                    ? "text-gray-400"
                    : "dark:text-white text-primary-green"
                }
              />
            </IconButton>

            <IconButton
              disabled={jaEstaAssinado}
              onClick={() => onActionDelete(idGestaoDistribuicaoEpi, true)}
            >
              <DynamicIcon
                nameIcon="DeleteForeverRounded"
                size={20}
                className={jaEstaAssinado ? "text-gray-400" : "text-red-500"}
              />
            </IconButton>
          </div>
        );
      },
    },
  ];
};